import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PaymentMethodDialog = ({ open, onClose, onSelect }) => {
  const handleSelection = (method) => {
    onSelect(method);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }}>
      เอกสารประกอบการขาย
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box display="flex" gap={1}>
          <Button
            fullWidth
            onClick={() => handleSelection('1')}
            color="success"
            variant="contained"
            sx={{ height: 60 }}
          >
            รายการสินค้า
          </Button>
          <Button
            fullWidth
            onClick={() => handleSelection('2')}
            color="info"
            variant="contained"
            sx={{ height: 60 }}
          >
            ใบขนส่งสินค้า
          </Button>
          <Button
            fullWidth
            onClick={() => handleSelection('3')}
            color="warning"
            variant="contained"
            sx={{ height: 60 }}
          >
            ใบแจ้งหนี้
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentMethodDialog;
